import { taskHasBeenPinned, relativeTimeSinceLastUpdate } from '../utils';

export function renderTaskCardHTML(data) {
  const { gid, name, memberships, modified_at, custom_fields } = data;

  const asanaTaskUrl = `https://app.asana.com/0/1120691940870388/${gid}/f`;

  const status = getBoardSectionName(memberships);
  const classByStatus = getClassNameFromStatus(status);

  const stageDesc = getDescriptionOfStageFromStatus(status);
  const pinState = taskHasBeenPinned(gid);

  let percentComplete = custom_fields.filter(
    field => field.name === 'Percent Complete'
  )[0].number_value;

  return /*html*/ `
  <div class="card request-card border-light mb-3 mx-auto w-50">
    <div class="card-header task-status ${classByStatus}">
      <strong>${status}</strong>
      <span
        data-task-id="${gid}"
        data-task-name="${name}"
        data-pin-state="${pinState}"
        style="position: absolute; right: 12px; cursor: pointer;"
        >${pinState ? '📍' : '📌'}</span
      >
      <small
          style="position: absolute; left: 12px;"
          >${relativeTimeSinceLastUpdate(modified_at)}</small
        >
    </div>
    <div class="card-body">
      <h4 class="card-title">${name}</h4>
      <p class="card-text">
        ${stageDesc}
      </p>

      <a class="btn btn-outline-light ${
        classByStatus === 'completed' ? null : 'd-none'
      }" href="${asanaTaskUrl}" target="_blank">Open Task in Asana</a>
      
      <div class="mt-3">
        <small class="text-center">ID: <a class="text-white" href="${asanaTaskUrl}" target="_blank">${gid}</a></small>
      </div>
    </div>
    <div class="card-footer">
      <div class="progress ${!!percentComplete ? null : 'd-none'}">
        <div
          class="progress-bar progress-bar-striped progress-bar-animated task-status ${classByStatus}"
          role="progressbar"
          style="width: ${percentComplete}%;"
          aria-valuenow="${percentComplete}"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          ${percentComplete}%
        </div>
      </div>
    </div>
  `;
}

function getBoardSectionName(memberships) {
  const projectRequestBoard = memberships.filter(member => {
    return member.project.gid === '1120691940870388';
  });

  return projectRequestBoard[0].section.name;
}

function getClassNameFromStatus(status) {
  switch (status) {
    case 'Pending Approval':
      return 'pending';
    case 'Approved / Ready to Start':
      return 'scheduled';
    case 'In Progress':
      return 'in-progress';
    case 'Complete / Review Required':
      return 'completed';
    case 'Complete / Resolved':
      return 'completed';
    case 'Disqualified':
      return 'bg-danger';
  }
}

function getDescriptionOfStageFromStatus(status) {
  switch (status) {
    case 'Pending Approval':
      return `Your task has not yet been reviewed by James ⏳. When it has, it will be <u>'Scheduled'</u> to start or <u>'Disqualified'</u>.`;
    case 'Approved / Ready to Start':
      return `James has reviewed your request and scheduled time to complete the task ✅. From here it will move to <u>'In Progress'</u>.`;
    case 'In Progress':
      return `Your task is currently being worked on by James 🔨. Be sure to <u>check back again soon</u> as he may need you to review his work.`;
    case 'Complete / Review Required':
      return 'James has completed your task 🎉! <b>He needs you to review</b> the task in Asana. Click the button below to open the task.';
    case 'Complete / Resolved':
      return `All done ⭐! James has fully completed your task. If you need anything further on this task, submit another request and reference this task ID. 💘`;
    case 'Disqualified':
      return `Oh no, your task has been disqualified 👎! This means that James has reviewed it and found it doesn't qualify for a request. Contact him for details.`;
  }
}
